import { useQuery } from '@tanstack/react-query';
import { useAccessSessionApi } from '@client-app-sdk';
import { GET_ACCESS_SESSION_REQUEST_TEMPLATE_QUERY_KEY } from '@client-app-sdk/hooks/access-sessions/query-keys';

function useGetAccessSessionRequestTemplate({ id }: { id: string }) {
  const api = useAccessSessionApi();
  return useQuery([GET_ACCESS_SESSION_REQUEST_TEMPLATE_QUERY_KEY, id], async () =>
    api.getAccessSessionRequestTemplate({ id }),
  );
}

export default useGetAccessSessionRequestTemplate;
